import React, { Fragment } from 'react';
import { Container, Row, Col, Input, Label, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import PermissionWrapper from '../../auth/PermissionWrapper';
import ConfirmButton from '../Modal/ConfirmButton';

class ClientMeetings extends React.Component {

    constructor(props) {
        super(props);

        this.blankMeeting = {
            date: this.props.clientData.meetings != null && this.props.clientData.meetings.length > 0 ? 
                new Date(new Date(this.props.clientData.meetings[0].date+'T00:00:00').setHours(0,0,0,0)+(60*60*24*30*1000)).toISOString().substring(0,10) : 
                new Date(new Date().setHours(0,0,0,0)+(60*60*24*30*1000)).toISOString().substring(0,10),
            meetingLeader: 0,
            cssiPersonnel: [],
            customerPersonnel: '',
            meetingNotes: '',
            nextSteps: ''
        }

        this.state = {
            newClientMeeting: JSON.parse(JSON.stringify(this.blankMeeting)),
            editClientMeeting: JSON.parse(JSON.stringify(this.blankMeeting)),
            editClientMeetingId: 0
        };

    }

    onChange = (e, edit) => {
        this.props.log('ClientMeetings.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        const stateVar = (edit) ? 'editClientMeeting' : 'newClientMeeting';
        this.setState(prevState => {
            const sel = { ...prevState };
            switch (e.target.name) {
                case "cssiPersonnel":
                    const inputArr = e.target.id.split('_');
                    if (sel[stateVar].cssiPersonnel.findIndex(item => item === parseInt(inputArr[1])) === -1 && e.target.checked) {
                        sel[stateVar].cssiPersonnel.push(parseInt(inputArr[1]))
                    } else if (sel[stateVar].cssiPersonnel.findIndex(item => item === parseInt(inputArr[1])) > -1 && !e.target.checked) {
                        sel[stateVar].cssiPersonnel.splice(sel[stateVar].cssiPersonnel.findIndex(item => item === parseInt(inputArr[1])), 1);
                    }
                    break;
                default:
                    sel[stateVar][e.target.name] = e.target.value;
            }
            return sel
        });
    }

    handleAdd = () => {
        this.props.log('ClientMeetings.js/handleAdd');
        const json_request = JSON.stringify({
            clientId: this.props.clientId,
            date: this.state.newClientMeeting.date,
            meetingLeader: this.state.newClientMeeting.meetingLeader,
            cssiPersonnel: this.state.newClientMeeting.cssiPersonnel,
            customerPersonnel: this.state.newClientMeeting.customerPersonnel,
            meetingNotes: this.state.newClientMeeting.meetingNotes,
            nextSteps: this.state.newClientMeeting.nextSteps,
        });
        fetch('/api/clientMeetings/', {
            method: 'POST',
            body: json_request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        }).then(results => results.json())
            .then(results => {
                results.success ?
                    this.setState({
                        newClientMeeting: JSON.parse(JSON.stringify(this.blankMeeting)),
                    }, () => {
                        this.props.getClientReports();
                        this.props.addToast('Meeting added successfully.', 5, 'success')
                    })
                    :
                    this.props.addToast('Unable to add meeting.', 5, 'danger');
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    };

    onEdit = (id) => {
        this.props.log('ClientMeetings.js/onEdit (id)', id);
        const meeting = [...this.props.clientData.meetings].filter(item => item.id === id)[0];
        this.setState({
            editClientMeeting: {
                id: id,
                clientId: this.props.clientId,
                date: meeting.date,
                meetingLeader: meeting.meetingLeader,
                cssiPersonnel: meeting.cssiPersonnel.split(',').map(item => parseInt(item)),
                customerPersonnel: meeting.customerPersonnel,
                meetingNotes: meeting.meetingNotes,
                nextSteps: meeting.nextSteps,
            },
            editClientMeetingId: id
        })
    }

    onDelete = (id) => {
        this.props.log('ClientMeetings.js/onDelete (id)', id);
        fetch('/api/clientMeetings/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.getClientReports();
                    this.props.addToast('Meeting deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete meeting.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleEdit = () => {
        this.props.log('ClientMeetings.js/handleAdd');
        const json_request = JSON.stringify({
            clientId: this.props.clientId,
            date: this.state.editClientMeeting.date,
            meetingLeader: this.state.editClientMeeting.meetingLeader,
            cssiPersonnel: this.state.editClientMeeting.cssiPersonnel,
            customerPersonnel: this.state.editClientMeeting.customerPersonnel,
            meetingNotes: this.state.editClientMeeting.meetingNotes,
            nextSteps: this.state.editClientMeeting.nextSteps,
        });
        fetch('/api/clientMeetings/' + this.state.editClientMeeting.id, {
            method: 'PUT',
            body: json_request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        }).then(results => results.json())
            .then(results => {
                results.success ?
                    this.setState({
                        editClientMeeting: JSON.parse(JSON.stringify(this.blankMeeting)),
                        editClientMeetingId: 0
                    }, () => {
                        this.props.getClientReports();
                        this.props.addToast('Meeting updated successfully.', 5, 'success')
                    })
                    :
                    this.props.addToast('Unable to update meeting.', 5, 'danger');
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleCancel = () => {
        this.props.log('ClientMeetings.js/handleCancel');
        this.setState({
            editClientMeeting: JSON.parse(JSON.stringify(this.blankMeeting)),
            editClientMeetingId: 0
        })
    }

    standardRow = (meeting) => {
        this.props.info('ClientMeetings.js/standardRow (meeting)', meeting);
        return (
            <Row className="adminRow pointer workflowRow" onClick={() => this.onEdit(meeting.id)}>
                <Col md={4} className="text-left">
                    {meeting.date}
                </Col>
                <Col md={4}>
                    {this.props.employees.findIndex(item => item.employeeId === parseInt(meeting.meetingLeader)) > -1 ? (
                        this.props.employees[this.props.employees.findIndex(item => item.employeeId === parseInt(meeting.meetingLeader))].lastName + ', ' +
                        this.props.employees[this.props.employees.findIndex(item => item.employeeId === parseInt(meeting.meetingLeader))].firstName
                    ) : 'No Meeting Leader'}
                </Col>
                <Col md={4} className="text-left">{meeting.customerPersonnel}</Col>
            </Row>
        )
    }

    editRow = (meeting) => {
        this.props.log('ClientMeetings.js/editRow (meeting)', meeting);
        return (<>
            <Row key={"edit" + meeting.id} className="adminRow activeTab align-items-bottom py-4 text-left">
                <Col md={3}>
                    <Row>
                        <Col>
                            <Input
                                type="date"
                                name="date"
                                value={this.props.isFieldNull(this.state.editClientMeeting.date)}
                                onChange={e => this.onChange(e, true)} />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Input
                                type="select"
                                name="meetingLeader"
                                value={this.props.isFieldNull(this.state.editClientMeeting.meetingLeader)}
                                onChange={e => this.onChange(e, true)} >
                                <option value="">Select Meeting Leader</option>
                                {this.props.employees.map(employee => (
                                    <option key={employee.employeeId} value={employee.employeeId}>{employee.lastName}, {employee.firstName}</option>
                                ))}
                            </Input>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col>
                            CSSI Personnel
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-left p-3 pl-5 maxHpanel">
                            {[...this.props.employees]
                                .map(employee => (
                                    <Row key={employee.employeeId}>
                                        <Label for={"cssiPersonnel_" + employee.employeeId}>
                                            <Input
                                                type="checkbox"
                                                name="cssiPersonnel"
                                                id={"cssiPersonnel_" + employee.employeeId}
                                                checked={this.props.isFieldNull(this.state.editClientMeeting.cssiPersonnel.findIndex(i => i === parseInt(employee.employeeId)) > -1, true)}
                                                onChange={e => this.onChange(e, true)}
                                            />{employee.lastName}, {employee.firstName}
                                        </Label>
                                    </Row>
                                ))}
                        </Col>
                    </Row>
                </Col>
                <Col md={7}>
                    <Row>
                        <Col>
                            <Input
                                placeholder="Customer Personnel"
                                type="textarea"
                                rows={6}
                                name="customerPersonnel"
                                value={this.props.isFieldNull(this.state.editClientMeeting.customerPersonnel)}
                                onChange={e => this.onChange(e, true)} />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Input
                                placeholder="Meeting Notes"
                                type="textarea"
                                rows={6}
                                name="meetingNotes"
                                value={this.props.isFieldNull(this.state.editClientMeeting.meetingNotes)}
                                onChange={e => this.onChange(e, true)} />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Input
                                placeholder="Next Steps"
                                type="textarea"
                                rows={6}
                                name="nextSteps"
                                value={this.props.isFieldNull(this.state.editClientMeeting.nextSteps)}
                                onChange={e => this.onChange(e, true)} />
                        </Col>
                    </Row>
                </Col>
                <Col md={2}>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Meetings">
                        <Button className="mx-1" color="success" onClick={this.handleEdit} title="Edit Meeting">
                            <FontAwesomeIcon icon={faCheck} />
                        </Button>
                    </PermissionWrapper>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Meetings">
                        <ConfirmButton className="mx-1" color="danger" onClick={() => this.onDelete(this.state.editClientMeeting.id)}>
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </ConfirmButton>
                    </PermissionWrapper>
                    <Button className="mx-1" color="secondary" onClick={this.handleCancel} title="Cancel">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
            </Row>
        </>
        )
    }

    addRow = () => {
        this.props.info('ClientMeetings.js/addRow');
        return (
            <>
                <Row className="py-4 text-left align-items-bottom ">
                    <Col md={3}>
                        <Row>
                            <Col>
                                <Input
                                    type="date"
                                    name="date"
                                    value={this.props.isFieldNull(this.state.newClientMeeting.date)}
                                    onChange={e => this.onChange(e)} />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Input
                                    type="select"
                                    name="meetingLeader"
                                    value={this.props.isFieldNull(this.state.newClientMeeting.meetingLeader)}
                                    onChange={e => this.onChange(e)} >
                                    <option value="">Select Meeting Leader</option>
                                    {this.props.employees.map(employee => (
                                        <option key={employee.employeeId} value={employee.employeeId}>{employee.lastName}, {employee.firstName}</option>
                                    ))}
                                </Input>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col>
                                CSSI Personnel
                            </Col>
                        </Row>
                        <Row>
                            <Col className="text-left p-3 pl-5 maxHpanel">
                                {[...this.props.employees]
                                    .filter(employee => employee.active)
                                    .sort((a,b) => a.firstName.localeCompare(b.firstName))
                                    .sort((a,b) => a.lastName.localeCompare(b.lastName))
                                    .map(employee => (
                                        <Row key={employee.employeeId}>
                                            <Label for={"cssiPersonnel_" + employee.employeeId}>
                                                <Input
                                                    type="checkbox"
                                                    name="cssiPersonnel"
                                                    id={"cssiPersonnel_" + employee.employeeId}
                                                    checked={this.props.isFieldNull(this.state.newClientMeeting.cssiPersonnel.findIndex(i => i === parseInt(employee.employeeId)) > -1, true)}
                                                    onChange={e => this.onChange(e)}
                                                />{employee.lastName}, {employee.firstName}
                                            </Label>
                                        </Row>
                                    ))}
                            </Col>
                        </Row>
                    </Col>
                    <Col md={7}>
                        <Row>
                            <Col>
                                <Input
                                    placeholder="Customer Personnel"
                                    type="textarea"
                                    rows={6}
                                    name="customerPersonnel"
                                    value={this.props.isFieldNull(this.state.newClientMeeting.customerPersonnel)}
                                    onChange={e => this.onChange(e)} />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Input
                                    placeholder="Meeting Notes"
                                    type="textarea"
                                    rows={6}
                                    name="meetingNotes"
                                    value={this.props.isFieldNull(this.state.newClientMeeting.meetingNotes)}
                                    onChange={e => this.onChange(e)} />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Input
                                    placeholder="Next Steps"
                                    type="textarea"
                                    rows={6}
                                    name="nextSteps"
                                    value={this.props.isFieldNull(this.state.newClientMeeting.nextSteps)}
                                    onChange={e => this.onChange(e)} />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={2}>
                        <Button
                            disabled={this.state.newClientMeeting.date === ''}
                            color="primary"
                            onClick={this.handleAdd}
                        >Add Meeting</Button>
                    </Col>

                </Row>
            </>
        )
    }

    render() {
        this.props.info('ClientMeetings.js/render');
        return (
            <Container className="text-left" fluid>
                <Row>
                    <Col md={3} className="pr-1">
                        <Label className="w-100">Frequency<Input
                            type="select"
                            onChange={(e) => this.props.handleUpdateClientInfo(this.props.clientId, { meetingFrequency: parseInt(e.target.value) > 0 ? parseInt(e.target.value) : null })}
                            value={this.props.isFieldNull(this.props.clientData.meetingFrequency)}
                        >   <option value="">Select</option>
                            <option value="2190">Quarterly</option>
                            <option value="4380">Bi-Annually</option>
                        </Input></Label>
                    </Col>
                </Row>
                {this.state.editClientMeetingId === 0 && 
                <Row className='font-weight-bold adminRow'>
                    <Col md={4}>Date</Col>
                    <Col md={4}>Meeting Leader</Col>
                    <Col md={4}>Customer Personnel</Col>
                </Row>}
                {this.props.clientData.meetings != null && this.props.clientData.meetings.map(meeting => (
                    <Fragment key={meeting.id}>{this.state.editClientMeetingId === meeting.id ? this.editRow(meeting) : this.standardRow(meeting)}</Fragment>
                ))}
                <Row>
                    <Col>
                        {this.addRow()}
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ClientMeetings;